import { useCallback } from 'react';
import type { ChatroomListType } from '../../types';

export type ChatroomSidebarContentFilter =
  | { search: string; type?: never }
  | { search?: never; type?: Exclude<ChatroomListType, 'all'> };

export const useGetChatroomSidebarContentFilter = () =>
  useCallback((search?: string, type?: ChatroomListType): ChatroomSidebarContentFilter => {
    const trimmedSearch = search?.trim();

    if (trimmedSearch) {
      return { search: trimmedSearch };
    }

    return { type: type === 'all' ? undefined : type };
  }, []);
